// eslint-disable-next-line
export const drawerWidth = 240;